import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
// import JsBarcode from "jsbarcode";
// import html2canvas from "html2canvas";
// import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
// import { Calendar } from "../../../common/imagePath";
// import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
// import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box } from "@mui/material";

const PayBillReport = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [nemultiselect, setnemultiselect] = useState({
    ReceivingType: [],
    Paymenttypename: [],
  });

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const [totalData, setTotalData] = useState({
    PaymentAmountsum: 0,
  });

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
    width: "22%",
  };

  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const paramObject = useParams();

  console.log(responseData, "responseData127");

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  //Function for export excel

  // to calculate the total

  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };
  const RolesDropdown = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "RolesDropdown");
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );
  console.log(reportdropdown, "reportdropdown");

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/paybillreport?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const data = res.data.ResponseData;
          setnemultiselect({
            TransactionType: [
              ...new Set(data?.map((item) => item?.Paymenttypename)),
            ],
            TransactionType: [
              ...new Set(data?.map((item) => item?.ReceivingType)),
            ],
          });

          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            AccountName: String(el.AccountName),
            PaymentAmount: el.PaymentAmount ? Number(el.PaymentAmount) : 0,
            // Location : String(el.Location)
          }));
          setResponseData(FilterData);
          setTotalData({
            ...totalData,
            PaymentAmountsum: FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.PaymentAmount) || 0),
              0
            ),
          });
        } else {
          setTotalData({
            ...totalData,
            PaymentAmountsum: 0,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });
  };

  const columns = useMemo(() => [
    {
      header: "Supplier Name",
      accessorKey: "SupplierName",
      filterFn: "contains",
    },
    {
      header: "Bill No",
      accessorKey: "BillNo",
      filterFn: "contains",
    },
    {
      header: "Location",
      accessorKey: "Location",
      filterFn: "contains",
    },
    {
      header: "Receiving Date",
      accessorKey: "ReceivingTime",
      filterFn: "contains",
      Cell: ({ row }) => {
        const ReceivingTime = moment(row.original.ReceivingTime);
        if (ReceivingTime.isValid()) {
          return moment(ReceivingTime).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Payment Date",
      accessorKey: "PaymentDate",
      filterFn: "contains",
      Cell: ({ row }) =>
        moment(row.original.PaymentDate).format("YYYY-MM-DD") === "Invalid date"
          ? ""
          : moment(row.original.PaymentDate).format(
              `${dateFormate.toUpperCase()}`
            ),
    },
    {
      header: "Payment Type",
      accessorKey: "Paymenttypename",
      filterSelectOptions: nemultiselect?.Paymenttypename, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
    },
    {
      header: "Bill Amount",
      accessorKey: "BillAmount",
      filterFn: "contains",
      Cell: ({ row }) => {
        const TotalAmount = row?.original?.BillAmount;
        if (TotalAmount == "0.00" || TotalAmount == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(TotalAmount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Payment Amount",
      accessorKey: "PaymentAmount",
      filterFn: "contains",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() =>
            window.open(`/receiving-paybills/${row.original.ReceivingTxnId}`)
          }
        >
          {CurrencySymbols(
            Number(row.original.PaymentAmount),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
      AggregatedCell: ({ cell, row }) => {
        const aggregatedValue = cell.getValue();
        const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

        const formattedValue =
          typeof aggregatedValue === "number" && isItemName
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "";

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        ) : null;
      },
    },
    {
      header: "Receiving Type",
      accessorKey: "ReceivingType",
      filterSelectOptions: nemultiselect?.ReceivingType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() =>
            window.open(`/receiving-receipt/${row.original.PosId}`)
          }
        >
          {row.original.ReceivingType}
        </Box>
      ),
    },
    {
      header: "Account Number",
      accessorKey: "Accountnumber",
      filterFn: "contains",
    },
    {
      header: "Account Name",
      accessorKey: "AccountName",
      filterFn: "contains",
    },
    {
      header: "Receiving ID",
      accessorKey: "PosId",
    },
  ]);

  // useEffect(() => {
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
  //   console.log(
  //     JSON.stringify(columnFilters) + " columnFilters | ",
  //     globalFilter + " globalFilter | ",
  //     pagination.pageIndex + " pagination.pageIndex | ",
  //     pagination.pageSize + " pagination.pageSize | ",
  //     columnIndex,
  //     sorting[0]?.id,
  //     sorting[0]?.desc === undefined
  //       ? "desc"
  //       : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
  //     startdate + " startdate | ",
  //     enddate + " enddate",
  //     "api Call payload"
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/paybillreport?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         const data = res.data.ResponseData;
  //         setnemultiselect({
  //           TransactionType: [
  //             ...new Set(data?.map((item) => item?.Paymenttypename)),
  //           ],
  //           TransactionType: [
  //             ...new Set(data?.map((item) => item?.ReceivingType)),
  //           ],
  //         });

  //         const FilterData = res.data.ResponseData?.map((el) => ({
  //           ...el,
  //           AccountName: String(el.AccountName),
  //           // Location : String(el.Location)
  //         }));
  //         // setnemultiselectortransectiontype(multiselectTransactionTypeTableFilter)
  //         setResponseData(FilterData);
  //         setData(FilterData);
  //         setRowCount(res.data.ResponseData[0].TotalRecord);
  //         setTotalData({
  //           ...totalData,
  //           PaymentAmountsum: res.data.ResponseData[0].PaymentAmountsum,
  //         });
  //       } else {
  //         setRowCount(0);
  //         setTotalData({
  //           ...totalData,
  //           PaymentAmountsum: 0,
  //         });
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  // ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">PaymentDetailReport</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Detailed PayBills Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
            
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <>
            <div
            className="row mt-3"
            style={{
              display: "grid",
              gap: "1rem",
              // gridTemplateColumns: "repeat(5,1fr)"
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            }}
          >
            <div className="cards">
              <div className="dash-widget" style={dashStyle}>
                <div className="dash-widgetimg"></div>
                <div className="dash-widgetcontent">
                  <p className="p-20">
                    {CurrencySymbols(
                      Number(totalData.PaymentAmountsum),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                  <div className="d-flex">
                    <p className="p-medium">Total</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="P">Sonar Pos</h6>
                    <p className="fw-bold p-regular">
                      Detailed PayBills Report
                    </p>
                    <div className="row">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Payment Detail Report"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnsVisibility={{
                      SupplierName: false,
                      BillNo: false,
                      BillAmount: false,
                    }}
                    columnGrouping={["PosId"]}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    enableRowSelection={false}
                  />
                </div>
              </div>
            </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PayBillReport;
